if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class carNote extends HTMLElement {
      constructor() {
        super();
        this.cartNoteData = this.querySelector("#cartNote");
        this.button = this.querySelector("button.button__save");

        this.carInit();
        this.button.addEventListener("click", this.onSave.bind(this));
      }

      carInit() {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((json) => {
            if(json.note !== null){
              this.cartNoteData.value = json.note;
            }
          })
          .catch((err) => console.log(err));
      }

      onSave() {
        let noteUpdate = this.cartNoteData.value;
        this.button.classList.add("loading");
        let body = JSON.stringify({
          note: noteUpdate,
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            if (response.ok) {
              this.button.classList.remove("loading");
              this.closest("details").removeAttribute("open");
              return response.json();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}

if (!customElements.get("shipping-calculator")) {
  customElements.define(
    "shipping-calculator",
    class ShippingCalculator extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button.button__save");

        this.shippingCountry = this.querySelector("#all--countries-shipping");
        this.countryState = this.querySelector("#AddressProvince_shipping");
        this.shippingCountryZip = this.querySelector("#ShippingAddressZip");

        this.shippingRatePackage = this.querySelector(".shipping_rate_package");
        this.shippingAddressWrapper = this.querySelector(
          ".shipping_rate_message"
        );
        this.shippingAddressCount = this.querySelector(
          ".shipping_address_count"
        );

        this.initCountries();
        this.button.addEventListener("click", this.onSave.bind(this));
      }

      initCountries() {
        if (this.shippingCountry && this.countryState) {
          if (Shopify && Shopify.CountryProvinceSelector) {
            new Shopify.CountryProvinceSelector(
              "all--countries-shipping",
              "AddressProvince_shipping",
              {
                hideElement: "AddressProvinceContainerNewShipping",
              }
            );
          }
        }
      }

      async onSave() {
        try {
          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();
          
          if (cartData.item_count === 0) {
            alert(window.cartStrings.empty_cart_message);
            return;
          }
        } catch (error) {
          console.error('Error fetching cart data:', error);
          return;
        }

        this.shippingAddressWrapper.classList.add("no-js-inline");

        if (this.shippingCountry.value !== "---") {
          this.shippingRatePackage.innerHTML = `<div class="mt-6"><p class="mb-0">${window.shipping.loading_message}</p></div>`;
          this.button.classList.add("loading");
          try {
            const response = await window.fetchShippingRatesAsync({
              zip: this.shippingCountryZip.value,
              country: this.shippingCountry.value,
              province: this.countryState.value,
            });
            if (response.shipping_rates.length === 0) {
              this.shippingRatePackage.innerHTML = `<p class="error">${window.shipping.out_of_range_message}</p>`;
              this.shippingAddressCount.innerText = "0";
              this.shippingAddressWrapper.classList.remove("no-js-inline");
              return;
            }
            this.shippingRatePackage.innerHTML = "";
            response.shipping_rates.map((item) => {
              let text = document.createElement("P");
              text.setAttribute("class", "mb-0");
              text.innerText = `${item.name}: ${shopCurrencySymbol}${item.price}`;
              this.shippingRatePackage.appendChild(text);
            });
            this.shippingAddressCount.innerText = `${response.shipping_rates.length}`;
            this.shippingAddressWrapper.classList.remove("no-js-inline");
          } catch (e) {
            this.shippingRatePackage.innerHTML = `<div class="mt-6"><p class="error">${e.message}</p></div>`;
          } finally {
            this.button.classList.remove("loading");
          }
        } else {
          this.shippingRatePackage.innerHTML = `<div class="mt-6"><p class="error">${window.shipping.country_label}</p></div>`;
        }
      }
    }
  );
}

if (!customElements.get("discount-code")) {
  customElements.define(
    "discount-code",
    class DiscountCode extends HTMLElement {
      constructor() {
        super();
        this.wrongMessage = this.querySelector(".coupon_wrong_message");
        this.input = this.querySelector("#coupon_code");
        this.button = this.querySelector("button.button__save");
        this.button.setAttribute("type", "button");

        this.button.addEventListener("click", this.onSave.bind(this));
        this.input.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            this.onSave();
          }
        });
      }

      async onSave() {
        const code = (this.input.value || "").trim();
        if (!code) {
          this.showError();
          return;
        }
        this.button.classList.add("loading");
        this.wrongMessage.classList.add("no-js-inline");

        try {
          const body = JSON.stringify({
            discount: code,
            sections: ["mini-cart-drawer"],
            sections_url: window.location.pathname,
          });
          const response = await fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{ body },
          });
          const cart = await response.json();
          const match = (cart.discount_codes || []).find(
            (entry) => entry.code.toLowerCase() === code.toLowerCase()
          );
          if (!match || !match.applicable) {
            this.showError();
            return;
          }
          this.renderDrawer(cart);
        } catch (error) {
          console.error(error);
          this.showError();
        } finally {
          this.button.classList.remove("loading");
        }
      }

      showError() {
        this.wrongMessage.classList.remove("no-js-inline");
      }

      renderDrawer(cart) {
        const drawer = document.getElementById("mini-cart-drawer");
        const html = cart.sections && cart.sections["mini-cart-drawer"];
        if (!drawer || !html) return;
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const inner = parsed.querySelector(".shopify-section");
        if (inner) drawer.innerHTML = inner.innerHTML;
      }
    }
  );
}

if (!customElements.get("gift-wrap-message")) {
  customElements.define(
    "gift-wrap-message",
    class GiftMessage extends HTMLElement {
      constructor() {
        super();
        this.giftMessage = this.querySelector("#giftMessage");
        this.button = this.querySelector("button.button__save");

        this.giftMessageInit();
        this.button.addEventListener("click", this.onSave.bind(this));
      }

      giftMessageInit() {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((json) => {
            if(json.attributes.hasOwnProperty('gift_note')){
              this.giftMessage.value = json.attributes.gift_note;
            }  
          })
          .catch((err) => console.log(err));
      }

      onSave() {
        let giftMessageValue = this.giftMessage.value;
        this.button.classList.add("loading");
        let body = JSON.stringify({
          attributes: { gift_note: giftMessageValue },
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            if (response.ok) {
              this.button.classList.remove("loading");
              this.closest("details").removeAttribute("open");
              return response.json();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
